/**
 * The application type where the errors can happen.
 *
 * @type {Readonly<{SIGNUP: number, SIGNUP_CONFIRM: number, AUTH_RESEND_CONFIRM_CODE: number, AUTH_FORGOT_PW: number, AUTH: number, COMMON: number}>}
 */
const ERROR_TYPE = Object.freeze({
  COMMON: 1,
  SIGNUP: 2,
  SIGNUP_CONFIRM: 3,
  AUTH: 4,
  AUTH_FORGOT_PW: 5,
  AUTH_RESEND_CONFIRM_CODE: 6,
})

/**
 * Internal use - Mapping ERROR_TYPEs to the files containing the translations.
 *
 * @type {string[]}
 * @private
 */
const _MAPPING = Object.freeze([
  null,
  '_common_errors.js',
  'signUp_errors.js',
  'signUpConfirm_errors.js',
  'auth_errors.js',
  'authForgotPw_errors.js',
  'authResendConfirmCode_errors.js',
])

/**
 * Handle the aws error to return one or more human readable error messages.
 *
 * @param errorType - the error type
 * @param e - the error
 * @return {String|Array|null} - a single string or an array of strings (in case one exception is mapping to multiple errors)
 */
function handleError(errorType, e) {
  let result = null
  let errorDefinitionFile
  let error

  // first: check common errors
  errorDefinitionFile = require('@/js/errorhandler/types/' + _MAPPING[ERROR_TYPE.COMMON])
  error = errorDefinitionFile.ERRORS.find(err => {
    if(e.code) {
      return err.code === e.code
    } else {
      return err.code === e.errorType
    }
  })
  if (error) {
    result = _getErrorMessage(error, e.message)
  }

  // second: check error type messages if it's no common error
  if (!result) {
    errorDefinitionFile = require('@/js/errorhandler/types/' + _MAPPING[errorType])
    console.log(errorDefinitionFile)
    error = errorDefinitionFile.ERRORS.find(err => err.code === e.code)
    if (error) {
      result = _getErrorMessage(error, e.message)
    }
  }

  // third: use generic error message
  if (!result) {
    result = {
      msg: 'Es ist ein technischer Fehler aufgetreten - Bitte versuche es später erneut'
    }
  }

  return result
}

/**
 * Internal use - Converts the js error into one or more error messages.
 *
 * @param errorObj - the found error object, see ./types/*.js
 * @param originalMsg - the original error message
 * @return {String|Array|null} - a single string or an array of strings (in case one exception is mapping to multiple errors)
 * @private
 */
function _getErrorMessage(errorObj, originalMsg) {
  let message

  if (errorObj.msgSubErrors) {
    let subErrorMsg = []

    errorObj.msgSubErrors.forEach(e => {
      // check the original error message if one exception is used for different errors
      if (originalMsg.includes(e.key)) {
        let exception = errorObj.code
        if (e.exception) {
          exception = e.exception
        }

        subErrorMsg.push({
          exception: exception,
          msg: e.msg
        })
      }
    })

    // no sub errors found in originalMsg (= error.message) -> use top-level msg as fallback
    message = subErrorMsg.length > 0 ? subErrorMsg : errorObj.msg
  } else {
    message = {
      exception: errorObj.code,
      msg: errorObj.msg
    }
  }

  return message
}

export {handleError, ERROR_TYPE}
